<template>
  <div
    class="modal fade"
    id="modal-form-seguimiento-viaje"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    style="background-color: #00000082"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header bg-geogo-top-left pt-2 pb-2">
          <h4 class="modal-title text-white">
            Seguimiento Viaje
          </h4>
          <button
            type="button"
            class="close text-white"
            data-dismiss="modal"
            aria-label="Close"
            id="close-modal"
            ref="closeModalSeguimiento"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-0 pt-1" v-if="viaje">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                id="tab-SeguimientoViaje"
                data-toggle="tab"
                href="#SeguimientoViaje"
              >
                Seguimiento Viaje
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="tab-SeguimientoMapa"
                data-toggle="tab"
                href="#SeguimientoMapa"
              >
                Mapa
              </a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade active show" id="SeguimientoViaje">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="position-relative p-3 bg-light border border-default shadow-sm"
                      style="border-radius: 0.8rem;"
                    >
                      <!-- Cinta decorativa -->
                      <div class="ribbon-wrapper ribbon-lg">
                        <div class="ribbon bg-info">
                          GENERAL
                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-md-3">
                          <div class="description-block">
                            <h5 class="description-header text-muted">
                              {{ viaje.transportadora.razon_social }}
                            </h5>
                            <span class="description-text text-secondary"
                              >EMPRESA</span
                            >
                          </div>
                        </div>
                        <div class="form-group col-md-2">
                          <div class="description-block">
                            <h5 class="description-header text-muted">
                              {{ viaje.vehiculo.placa }}
                            </h5>
                            <span class="description-text text-secondary"
                              >VEHÍCULO</span
                            >
                          </div>
                        </div>
                        <div class="form-group col-sm-2">
                          <div class="description-block">
                            <h5 class="description-header text-muted">
                              {{
                                viaje.remolque
                                  ? viaje.remolque.placa
                                  : "Sin Asignar"
                              }}
                            </h5>
                            <span class="description-text text-secondary"
                              >REMOLQUE</span
                            >
                          </div>
                        </div>
                        <div class="form-group col-sm-3">
                          <div class="description-block">
                            <h5
                              class="description-header text-muted text-nowrap"
                            >
                              {{ viaje.conductor.nombres }}
                              {{ viaje.conductor.apellidos }}
                              <span class="badge bg-info text-muted">
                                {{ viaje.conductor.numero_documento }}
                              </span>
                            </h5>
                            <span class="description-text text-secondary"
                              >CONDUCTOR</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-12">
                    <div class="card" style="border-radius: 0.8rem;">
                      <div class="card-body">
                        <div class="row justify-content-center">
                          <div class="form-group col-md-4">
                            <label for="">Tipo Vehículo</label>
                            <input
                              type="text"
                              v-model="viaje.tipo_vehiculo.nombre"
                              class="form-control form-control-sm"
                              disabled
                            />
                          </div>
                          <div class="form-group col-md-4">
                            <label for="">Sitio Cargue</label>
                            <input
                              type="text"
                              v-model="viaje.sitio_cargue.nombre"
                              class="form-control form-control-sm"
                              disabled
                              v-if="viaje.sitio_cargue_id"
                            />
                            <input
                              type="text"
                              placeholder="Sin Asignar"
                              class="form-control form-control-sm"
                              disabled
                              v-else
                            />
                          </div>
                          <div class="form-group col-md-4">
                            <label for="">Sitio Descargue</label>
                            <input
                              type="text"
                              v-model="viaje.sitio_descargue.nombre"
                              class="form-control form-control-sm"
                              disabled
                              v-if="viaje.sitio_descargue_id"
                            />
                            <input
                              type="text"
                              placeholder="Sin Asignar"
                              class="form-control form-control-sm"
                              disabled
                              v-else
                            />
                          </div>
                          <div class="form-group col-md-4">
                            <label for="">Dirección</label>
                            <input
                              type="text"
                              v-model="form.direccion"
                              :class="[
                                'form-control form-control-sm',
                                $v.form.direccion.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                            />
                          </div>
                          <div class="form-group col-md-2">
                            <label for="">Fecha Reporte</label>
                            <input
                              type="date"
                              v-model="form.fecha_reporte"
                              :class="[
                                'form-control form-control-sm',
                                $v.form.fecha_reporte.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                            />
                          </div>
                          <div class="form-group col-md-2">
                            <label for="">Hora Reporte</label>
                            <input
                              type="text"
                              v-model="form.hora_reporte"
                              v-mask="{
                                mask: '99:99:99',
                                hourFormat: '24',
                              }"
                              :class="[
                                'form-control form-control-sm',
                                $v.form.hora_reporte.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                            />
                          </div>
                          <div class="form-group col-md-2">
                            <label for="">Latitud</label>
                            <input
                              type="text"
                              v-model="form.latitud"
                              :class="[
                                'form-control form-control-sm',
                                $v.form.latitud.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                            />
                          </div>
                          <div class="form-group col-md-2">
                            <label for="">Longitud</label>
                            <input
                              type="text"
                              v-model="form.longitud"
                              :class="[
                                'form-control form-control-sm',
                                $v.form.longitud.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                            />
                          </div>
                          <div class="form-group col-md-4">
                            <label for="">Novedad</label>
                            <v-select
                              placeholder="Novedad"
                              @input="selectNovedad()"
                              label="descripcion"
                              class="form-control form-control-sm p-0"
                              v-model="novedad"
                              :class="[
                                $v.form.novedad.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                              ]"
                              :options="listasForms.novedades"
                            ></v-select>
                          </div>
                          <div class="form-group col-md-4">
                            <label for="">Estado</label>
                            <v-select
                              placeholder="Estado"
                              @input="selectEstado()"
                              label="descripcion"
                              class="form-control form-control-sm p-0"
                              v-model="estado"
                              :class="[
                                $v.form.estado.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                                $store.getters.getDarkMode
                                  ? 'dark-vselect'
                                  : '',
                              ]"
                              :options="listasForms.estados"
                            ></v-select>
                          </div>
                          <div class="form-group col-md-4">
                            <label for="">Observaciones</label>
                            <textarea
                              placeholder="Observaciones"
                              v-model="form.observacion"
                              :class="[
                                $v.form.observacion.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                                'form-control form-control-sm',
                              ]"
                            ></textarea>
                          </div>
                          <div class="col-md-2 text-center pt-5">
                            <button
                              type="button"
                              class="btn btn-sm btn-primary"
                              v-if="!$v.form.$invalid"
                              @click="save()"
                            >
                              Guardar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-3" v-if="viaje && viaje.seguimientos.length">
                  <div class="col-md-12">
                    <div class="card card-primary collapsed-card">
                      <div class="card-header">
                        <h3 class="card-title">Seguimientos Realizados</h3>
                        <div class="card-tools">
                          <button
                            type="button"
                            class="btn btn-tool"
                            data-card-widget="collapse"
                          >
                            <i class="fas fa-plus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body" style="display: none;">
                        <div class="col-md-12 table-responsive">
                          <table
                            class="table table-bordered table-striped table-hover table-sm text-nowrap text-center"
                          >
                            <thead class="bg-dark">
                              <tr>
                                <th>#</th>
                                <th>Usuario</th>
                                <th>Fecha Reporte</th>
                                <th>Dirección</th>
                                <th>Novedad</th>
                                <th>Longitud</th>
                                <th>Latitud</th>
                                <th>Estado</th>
                                <th>Observación</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(seguimiento,
                                index) in viaje.seguimientos"
                                :key="index"
                              >
                                <td>{{ index + 1 }}</td>
                                <td>{{ seguimiento.responsable_user.name }}</td>
                                <td>{{ seguimiento.fecha_reporte }}</td>
                                <td>
                                  {{ seguimiento.direccion }}
                                </td>
                                <td>
                                  {{ seguimiento.novedadSeguimiento }}
                                </td>
                                <td>
                                  {{ seguimiento.longitud }}
                                </td>
                                <td>
                                  {{ seguimiento.latitud }}
                                </td>
                                <td>
                                  {{ seguimiento.estadoSeguimiento }}
                                </td>
                                <td>
                                  {{ seguimiento.observacion }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-12">
                    <div class="card-footer hold-transition">
                      <div class="row justify-content-center">
                        <div class="col-md-2 text-center">
                          <label
                            class="badge text-dark text-md mr-2 mb-0 align-top"
                            :class="[
                              markers.traza.length ? 'bg-navy' : 'bg-light',
                              cargando_btn_traza ? 'overlay-wrapper' : '',
                            ]"
                          >
                            <div v-if="cargando_btn_traza" class="overlay">
                              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                            </div>
                            <div class="custom-control custom-checkbox">
                              <input
                                v-model="flag_traza"
                                type="checkbox"
                                id="viewTraza"
                                class="custom-control-input"
                                :disabled="markers.traza.length == 0"
                              />
                              <label
                                for="viewTraza"
                                class="custom-control-label"
                              >
                                <i
                                  class="fas fa-location-arrow text-xl p-1"
                                ></i>
                              </label>
                            </div>
                            <div class="text-center">
                              <span
                                class="badge"
                                :class="
                                  markers.traza.length
                                    ? 'bg-sos-green'
                                    : 'bg-danger'
                                "
                              >
                                {{
                                  markers.traza.length
                                    ? "Traza Gps"
                                    : "Sin Trazabilidad"
                                }}
                              </span>
                            </div>
                          </label>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div :class="flag_traza ? 'col-md-7' : 'col-md-12'">
                          <!--  <div class="row"> -->
                          <div v-if="cargando_mapa" class="overlay">
                            <i class="fas fa-5x fa-sync-alt fa-spin"></i>
                            <div class="text-lg pt-2">Cargando...</div>
                          </div>
                          <gmap-map
                            class="border border-dark"
                            :center="center"
                            :zoom="zoom"
                            style="width: 100%; height: 460px;"
                            :options="{
                              disableDefaultUI: true,
                              zoomControl: true,
                              mapTypeControl: true,
                            }"
                            @click="addMarkers"
                          >
                            <!-- Markers de seguimientos -->
                            <gmap-marker
                              v-for="(m, index) in markers.seguimiento"
                              :key="index"
                              :position="m.position"
                              :icon="m.icon"
                              :draggable="false"
                              :clickable="false"
                              @click="
                                (center = m.position),
                                  toggleInfoWindow(
                                    m.position,
                                    m.id,
                                    m.info,
                                    'segui'
                                  )
                              "
                            ></gmap-marker>
                            <!-- Markers ultima posicion vehículo -->
                            <gmap-marker
                              v-if="markers.ultimo_registro"
                              :position="markers.ultimo_registro.position"
                              :icon="markers.ultimo_registro.icon"
                            ></gmap-marker>
                            <!-- Markers de trazabilidad -->
                            <div v-if="markers.traza.length > 0 && flag_traza">
                              <gmap-marker
                                v-for="(m, index) in markers.traza"
                                :key="index"
                                :position="m.position"
                                :icon="m.icon"
                                :animation="2"
                                @click="
                                  (center = m.position),
                                    toggleInfoWindow(
                                      m.position,
                                      m.id,
                                      m.info,
                                      'traza'
                                    )
                                "
                              ></gmap-marker>
                            </div>
                            <!-- popup -->
                            <gmap-info-window
                              :options="infoOptions"
                              :position="infoWindowPos"
                              :opened="infoWinOpen"
                              @closeclick="infoWinOpen = false"
                            >
                              <div
                                v-html="infoContent"
                                :class="
                                  tipoMarker == 'traza' ? 'no-select' : ''
                                "
                              ></div>
                            </gmap-info-window>
                          </gmap-map>
                        </div>
                        <div v-if="flag_traza" class="form-group col-md-5">
                          <table
                            class="table table-bordered table-striped table-hover table-sm text-nowrap table-responsive"
                          >
                            <thead class="bg-dark">
                              <tr>
                                <th>#</th>
                                <th>Fecha</th>
                                <th>Placa</th>
                                <th>Latitud</th>
                                <th>Longitud</th>
                                <th>Velocidad</th>
                                <th>Dirección</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(traza, index) in vehiculo.gps"
                                :key="index"
                              >
                                <td>{{ index + 1 }}</td>
                                <td>{{ traza.dtefechareporte }}</td>
                                <td class="text-center">
                                  {{ traza.strplaca }}
                                </td>
                                <td class="text-center">
                                  {{ traza.dbllatitud }}
                                </td>
                                <td class="text-center">
                                  {{ traza.dbllongitud }}
                                </td>
                                <td class="text-center">
                                  {{ traza.intvelocidadinstantanea }}
                                </td>
                                <td>
                                  <small>{{ traza.strdireccion }}</small>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="SeguimientoMapa">
              <VentanaOperacionesSeguimientoMapa
                ref="ventanaOperacionesSeguimientoMapa"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import vSelect from "vue-select";
import { required, helpers } from "vuelidate/lib/validators";
import VentanaOperacionesSeguimientoMapa from "./VentanaOperacionesSeguimientoMapa";
const timeFormat = helpers.regex(
  "timeFormat",
  /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/
);
const google = window.google;

export default {
  name: "VentanaOperacionesSeguimientoViaje",

  components: {
    vSelect,
    VentanaOperacionesSeguimientoMapa,
  },
  data() {
    return {
      viaje: null,
      estado: {},
      novedad: {},
      vehiculo: {},
      form: {
        viaje_type: "App\\Viaje",
        viaje_id: null,
        direccion: null,
        fecha_reporte: null,
        hora_reporte: null,
        novedad: null,
        latitud: null,
        longitud: null,
        observacion: null,
        estado: null,
      },
      listasForms: {
        novedades: [],
        estados: [],
      },
      seguimientoExpandidoIndex: null,
      // Mapa
      cargando_btn_traza: false,
      cargando_btn_ruta: false,
      cargando_mapa: false,
      flag_traza: false,
      markers: {
        seguimiento: [],
        traza: [],
        ultimo_registro: {},
      },
      center: {},
      zoom: 10,
      infoContent: "",
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      tipoMarker: "",
    };
  },
  validations() {
    return {
      form: {
        direccion: {
          required,
        },
        fecha_reporte: {
          required,
        },
        hora_reporte: {
          required,
          timeFormat,
        },
        novedad: {
          required,
        },
        latitud: {
          required,
        },
        longitud: {
          required,
        },
        observacion: {
          required,
        },
        estado: {
          required,
        },
      },
    };
  },

  methods: {
    async llenarModal(viaje_id) {
      let self = this;
      self.$parent.$parent.cargando = true;
      self.flag_traza = false;
      self.cargando_mapa = true;
      let url =
        "api/hidrocarburos/ventanasEnturnamientoOperacion/seguimientoViaje";
      await axios
        .get(url, {
          params: {
            viaje_id: viaje_id,
          },
        })
        .then(async function(response) {
          await self.getaData(response.data);
          self.viaje = response.data;
          self.cargando_mapa = false;
          self.$parent.$parent.cargando = false;
        })
        .catch(function(error) {
          self.$swal({
            icon: "error",
            title: "Ocurrió un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          self.cargando_mapa = false;
          self.$parent.$parent.cargando = false;
        });
    },

    async getaData(viaje) {
      this.limpiarMapa();
      await this.getRegistrosGPS(viaje);
      await this.llenarMapa();
      await this.getEstado();
      await this.getNovedad();
    },

    async getEstado() {
      await axios.get("/api/lista/222").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    async getNovedad() {
      await axios.get("/api/lista/223").then((response) => {
        this.listasForms.novedades = response.data;
      });
    },

    selectEstado() {
      this.form.estado = null;
      if (this.estado) {
        this.form.estado = this.estado.numeracion;
      }
    },

    selectNovedad() {
      this.form.novedad = null;
      if (this.novedad) {
        this.form.novedad = this.novedad.numeracion;
      }
    },

    save() {
      if (!this.$v.form.$invalid) {
        /* this.$parent.$parent.cargando = true; */
        this.$swal({
          title: "Esta seguro de guardar este seguimiento?",
          text: "Los cambios no se pueden revertir!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si, Guardar!",
        }).then((result) => {
          if (result.value) {
            axios({
              method: "PUT",
              url:
                "/api/hidrocarburos/ventanasEnturnamientoOperacion/saveSeguimiento",
              data: this.form,
            })
              .then(() => {
                this.$refs.closeModalSeguimiento.click();
                this.$parent.$parent.getIndex();
                this.$swal({
                  icon: "success",
                  title: "El seguimiento se guardó exitosamente...",
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
              })
              .catch((e) => {
                this.$swal({
                  icon: "error",
                  title: "Ocurrió un error, vuelva a intentarlo... " + e,
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
              });
          }
        });
      }
    },

    // Mapa
    async addMarkers(event) {
      // Datos del origen
      if (this.form.vehiculo_id) {
        this.markers.seguimiento = [];
        this.form.latitud = parseFloat(event.latLng.lat());
        this.form.longitud = parseFloat(event.latLng.lng());
        const destino = {
          lat: parseFloat(event.latLng.lat()),
          lng: parseFloat(event.latLng.lng()),
        };
        this.center = destino;
        this.markers.seguimiento.push({
          position: destino,
          icon: "/img/maps/call.png",
        });
      }
    },

    async llenarMapa() {
      this.markers.seguimiento = [];
      this.markers.ultimo_registro = null;
      if (this.vehiculo.data) {
        // Datos del origen
        if (this.vehiculo.data.ultimo_registro_post_sql) {
          this.form.latitud = this.vehiculo.data.ultimo_registro_post_sql
            .gps_post_sql
            ? parseFloat(
                this.vehiculo.data.ultimo_registro_post_sql.gps_post_sql
                  .dbllatitud
              )
            : 4.651371;
          this.form.longitud = this.vehiculo.data.ultimo_registro_post_sql
            .gps_post_sql
            ? parseFloat(
                this.vehiculo.data.ultimo_registro_post_sql.gps_post_sql
                  .dbllongitud
              )
            : -74.071509;
          this.center = {
            lat:
              this.vehiculo.data.ultimo_registro_post_sql.gps_post_sql != null
                ? parseFloat(
                    this.vehiculo.data.ultimo_registro_post_sql.gps_post_sql
                      .dbllatitud
                  )
                : 4.651371,
            lng:
              this.vehiculo.data.ultimo_registro_post_sql.gps_post_sql != null
                ? parseFloat(
                    this.vehiculo.data.ultimo_registro_post_sql.gps_post_sql
                      .dbllongitud
                  )
                : -74.071509,
          };
          let data_gps =
            this.vehiculo.data.ultimo_registro_post_sql.gps_post_sql != null
              ? this.vehiculo.data.ultimo_registro_post_sql.gps_post_sql
              : null;

          this.form.direccion =
            this.vehiculo.data.ultimo_registro_post_sql.gps_post_sql != null
              ? this.vehiculo.data.ultimo_registro_post_sql.gps_post_sql
                  .strdireccion
              : null;

          // Se llena los datos del seguimiento
          this.markers.seguimiento.push({
            position: this.center,
            icon: "/img/maps/call.png",
            info: `
					<h3 class="text-center text-sm mb-0">${this.vehiculo.data.placa}</h3>
					<hr class="m-0 mt-1 mb-1">
					<p class="mb-0 text-secundary"><small><b> Fecha Ultimo Reporte:</b> ${
            data_gps && data_gps.dtefechareporte ? data_gps.dtefechareporte : ""
          }</small></p>
					<p class="mb-0 text-secundary"><small><b> Latitud:</b> ${
            data_gps && data_gps.dbllatitud ? data_gps.dbllatitud : ""
          }</small></p>
					<p class="mb-0"><small><b>Longitud:</b> ${
            data_gps && data_gps.dbllongitud ? data_gps.dbllongitud : ""
          }</small></p>
					<p class="mb-0"><small><b>Dirección:</b> ${
            data_gps && data_gps.strdireccion ? data_gps.strdireccion : ""
          }</small></p>
					<p class="mb-0"><small><b>Doc. transportadora:</b> ${
            data_gps && data_gps.strdoctransportadora
              ? data_gps.strdoctransportadora
              : ""
          }</small></p>
					<p class="mb-0"><small><b>Velocidad:</b> ${
            data_gps && data_gps.intvelocidadinstantanea
              ? data_gps.intvelocidadinstantanea
              : ""
          }</small></p>`,
          });

          // Se llena la información de la última posición del vehículo
          if (data_gps) {
            const path = `
					<svg xmlns="http://www.w3.org/2000/svg" width="80" height="30">
						<circle cx="13" cy="13.5" r="13" stroke="white" stroke-width="2" fill="#00529c"
						transform="rotate(${
              data_gps.intheading
                ? parseFloat(data_gps.intheading.replace(",", ".")) - 180
                : -180
            }, 13, 13)"
						></circle>
						<path fill="#b0c442" stroke="white" stroke-width="1" d="M 7 7 L 13 11 L 19 7 L 13 21 Z"></path>
						<rect width="39" height="15" fill="black" stroke="black" x="26" y="6"></rect>
						<text font-size="10" font-family="" x="28" y="16" fill="white">
						${this.vehiculo.data.placa}
						</text>
					</svg>
					`;
            const encodedPath = encodeURIComponent(path);
            const iconUrl = "data:image/svg+xml;charset=UTF-8," + encodedPath;

            let svgMarker = {
              url: iconUrl,
              fillColor: "#b0c442",
              fillOpacity: 1,
              strokeColor: "#00529c",
              strokeWeight: 1,
              strokeOpacity: 0.7,
              rotation: data_gps.intheading
                ? parseFloat(data_gps.intheading.replace(",", ".")) - 180
                : -180,
              scale: 0.7,
              anchor: new google.maps.Point(15, 30),
            };

            this.markers.ultimo_registro = {
              position: {
                lat:
                  data_gps != null ? parseFloat(data_gps.dbllatitud) : 4.651371,
                lng:
                  data_gps != null
                    ? parseFloat(data_gps.dbllongitud)
                    : -74.071509,
              },
              icon: svgMarker,
            };
          }

          this.zoom = 10;
          this.$swal({
            customClass: {
              container: "my-swal",
            },
            icon: "success",
            title: "Por favor elija la ubicación en el mapa",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        } else {
          this.form.latitud = 4.651371;
          this.form.longitud = -74.071509;
          this.center = {
            lat: 4.651371,
            lng: -74.071509,
          };
          this.markers.seguimiento.push({
            position: this.center,
            icon: "/img/maps/call.png",
            info: `
					<h3 class="text-center text-sm mb-0">${this.vehiculo.data.placa}</h3>
					<hr class="m-0 mt-1 mb-1">
					<p class="mb-0 text-center"><small><b>No se encontraron datos de GPS para este vehículo.</b></small></p>
				`,
          });
          this.zoom = 10;
          this.$swal({
            customClass: {
              container: "my-swal",
            },
            icon: "success",
            title: "Por favor elija la ubicación en el mapa",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        }
      }
    },

    toggleInfoWindow: function(position, idx, ventana, tipoMarker) {
      this.infoWindowPos = position;
      this.infoContent = ventana;
      this.tipoMarker = tipoMarker;
      //compruebe si es el mismo marcador que se seleccionó en caso afirmativo alternar
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si es un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    toggleInfoWindowPoli: function(poli, idx, ventana, tipoMarker) {
      this.infoWindowPos = poli.path[0];
      this.infoContent = ventana;
      this.center = poli.path[0];
      this.tipoMarker = tipoMarker;

      //compruebe si es el mismo marcador que se seleccionó y en caso afirmativo alternar
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    toggleInfoWindowCir: function(cir, idx, ventana, tipoMarker) {
      this.infoWindowPos = cir.center;
      this.infoContent = ventana;
      this.center = cir.center;
      this.tipoMarker = tipoMarker;

      //compruebe si es el mismo marcador que se seleccionó y en caso afirmativo alternar
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    limpiarMapa() {
      this.markers = {
        seguimiento: [],
        traza: [],
        ultimo_registro: {},
      };

      if (this.$refs.ventanaOperacionesSeguimientoMapa) {
        this.$refs.ventanaOperacionesSeguimientoMapa.form = {
          traza: false,
          novedades: false,
        };
      }
    },

    async getRegistrosGPS(viaje) {
      this.markers.traza = [];
      this.cargando_btn_traza = true;
      await axios
        .get("/api/admin/vehiculos/gps/registros", {
          params: {
            vehiculo_id: viaje.vehiculo_id,
            viaje_id: viaje.id,
            limit: 13,
          },
        })
        .then((response) => {
          this.vehiculo = response.data;
          this.form = {
            viaje_type: "App\\Viaje",
            viaje_id: viaje.id,
            latitud: null,
            longitud: null,
            direccion: null,
            novedad: null,
            observacion: null,
            estado: null,
            fecha_reporte:
              this.vehiculo &&
              this.vehiculo.data &&
              this.vehiculo.data.ultimo_registro_post_sql
                ? this.vehiculo.data.ultimo_registro_post_sql.fecha_hora_ultimo_reporte.slice(
                    0,
                    10
                  )
                : null,
            hora_reporte:
              this.vehiculo &&
              this.vehiculo.data &&
              this.vehiculo.data.ultimo_registro_post_sql
                ? this.vehiculo.data.ultimo_registro_post_sql.fecha_hora_ultimo_reporte.slice(
                    11,
                    19
                  )
                : null,
          };
          if (response.data.gps.length > 0) {
            response.data.gps.forEach((gps) => {
              const marker = {
                lat: parseFloat(parseFloat(gps.dbllatitud.replace(",", "."))),
                lng: parseFloat(parseFloat(gps.dbllongitud.replace(",", "."))),
              };

              let fillColorText = "#b0c442"; // Relleno
              let strokeColorText = "#00529c"; // Borde

              fillColorText =
                parseFloat(gps.intvelocidadinstantanea) > 0
                  ? "#42c342"
                  : "#a2a2a2";
              strokeColorText =
                parseFloat(gps.intvelocidadinstantanea) > 0
                  ? "#478c47"
                  : "#515151";

              // Se crea el icono vectorial
              const path = "M 0 0 L 15 10 L 30 0 L 15 40 Z";
              let svgMarker = {
                path,
                fillColor: fillColorText,
                strokeColor: strokeColorText,
                fillOpacity: 1,
                strokeWeight: 1,
                strokeOpacity: 0.7,
                rotation: gps.intheading
                  ? parseFloat(gps.intheading.replace(",", ".")) - 180
                  : -180,
                scale: 0.6,
                anchor: new google.maps.Point(15, 30),
              };

              this.markers.traza.push({
                id: gps.id,
                position: marker,
                info: `
									<h3 class="text-sm text-center mb-0">${gps.strplaca}</h3>
									<hr class="m-0 mt-1 mb-1">
									<p class="mb-0"><strong>Fecha de reporte: ${gps.dtefechareporte}</strong></p>
									<p class="mb-0"><strong>Velocidad: ${gps.intvelocidadinstantanea}<small>Km/h</small></strong></p>
									<p class="mb-0"><strong>Direccion: ${gps.strdireccion}</strong></p>
									<p class="mb-0"><strong>Latitud: ${gps.dbllatitud} Logintud: ${gps.dbllongitud}</strong></p>
								`,
                icon: svgMarker,
              });
              this.cargando_btn_traza = false;
              this.flag_traza = true;
            });
          }
        });
    },
  },
};
</script>
